<template>
  <div :class="['selectboxit-container', isCollapsed ? '' : 'selectboxit-expanded']" v-if="options && options.length">
    <button class="selectboxit-btn" type="button" @click="toggle">
      <span class="selectboxit-option-icon-container">
        <i class="selectboxit-default-icon selectboxit-option-icon"></i>
      </span>
      <span v-if="selected" class="selectboxit-text">
        <font style="vertical-align: inherit;"><font style="vertical-align: inherit;">{{selected[labelField]}}</font></font>
      </span>
      <span v-else class="selectboxit-placeholder">
        <font style="vertical-align: inherit;"><font style="vertical-align: inherit;">{{placeholder}}</font></font>
      </span>
      <span class="selectboxit-arrow-container">
        <i class="selectboxit-arrow selectboxit-default-arrow"></i>
      </span>
    </button>
    <ul class="selectboxit-options selectboxit-list">
      <li :class="['selectboxit-option', selected && selected[valueField] == item[valueField] ? 'selectboxit-option__active' : '']" v-for="(item, index) in options" :key="index" @click="setSelected(item)">
        <a class="selectboxit-option-anchor">
          <span class="selectboxit-option-icon-container"><i class="selectboxit-option-icon selectboxit-container"></i></span>
          <font style="vertical-align: inherit;"><font style="vertical-align: inherit;">{{item[labelField]}}</font></font>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'SelectBoxIt',
    props: {
      options: {
        type: Array,
        required: true
      },
      labelField: { type: String, default: "label" },
      valueField: { type: String, default: "value" },
      value: { type: [String, Number, Object], default: null },
      placeholder: { type: String, default: "请选择" }
    },
    data() {
      return {
        isCollapsed: true,
        selected: null
      }
    },
    created() {
      this.value && this.initValues();
    },
    methods: {
      initValues() {
        if (Array.isArray(this.options) && this.options.length) {
          let { value: defVal, labelField, valueField } = this;
          let matched = this.options.find((item) => {
            if (typeof defVal == 'object' && defVal[labelField] == item[labelField] && defVal[valueField] == item[valueField]) {
              return true;
            } else if (!isNaN(defVal) && item[valueField] == defVal) {
              return true;
            } else if (defVal == item[labelField]) {
              return true;
            } else {
              return false;
            }
          });
          matched && (this.selected = {...matched});
        }
      },
      toggle() {
        this.isCollapsed ? this.showPicker() : this.hidePicker();
        if (!this.isCollapsed) {
          window.addEventListener("click", this.clickHandler, false);
        } else {
          window.removeEventListener("click", this.clickHandler, false);
        }
      },
      clickHandler(evt) {
        let dom = evt.target || evt.srcElement;
        if (!this.$el.contains(dom)) {
          this.hidePicker();
        }
      },
      showPicker() {
        this.isCollapsed = false;
      },
      hidePicker() {
        this.isCollapsed = true;
      },
      setSelected(item) {
        this.selected = {...item};
        this.hidePicker();
        this.$emit('select', { ...item });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .selectboxit-container {
    display: block; width: 100%; height: 2.8125rem; background: #fff; border: .0625rem solid #cacaca; border-radius: 3.125rem; position: relative;
    .selectboxit-btn {
      display: block; width: 100%; height: 2.8125rem; padding: .75rem 1.125rem; text-align: left; cursor: pointer;
      .selectboxit-option-icon { display: none; }
      .selectboxit-placeholder { font-family: HelveticaNeueLTW05-45Light,arial,sans-serif; color: #575757; }
      .selectboxit-text { font-family: HelveticaNeueLTW05-45Light,arial,sans-serif; color: #575757; }
      .selectboxit-arrow-container {
        display: block; width: .625rem; height: .625rem;
        background-image: url('../assets/imgs/icons/arrow.svg');
        background-repeat: no-repeat;
        background-position: 50%;
        position: absolute; top: 50%; right: .9375rem;
        transform: translateY(-50%) translateY(-.5px);
        transform: rotate(180deg) translateY(50%) translateY(-.5px);
      }
    }
    .selectboxit-list {
      display: none; width: 100%; max-height: 210px; padding: .625rem; margin-top: .3125rem; overflow: auto;
      position: absolute; top: auto; left: 0; z-index: 2; background: #fff; border-radius: .6875rem; box-shadow: 0 0 0.625rem 0 #ccc;
      .selectboxit-option {
        .selectboxit-option-anchor {
          display: block;
          text-decoration: none;
          padding: .625rem;
          border-radius: .5rem;
          font-family: HelveticaNeueLTW05-45Light,arial,sans-serif;
          .selectboxit-option-icon { display: none; }
        }
        &:hover, &.selectboxit-option__active {
          .selectboxit-option-anchor {
            background-color: #f5f5f5;
            color: #575757;
            text-decoration: underline;
          }
        }
      }      
    }
    &.selectboxit-expanded {
      .selectboxit-btn .selectboxit-arrow-container { transform: rotate(0deg); top: 41%; }
      .selectboxit-list { display: block; }
    }
  }
</style>